import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const DEBUG = process.env.NODE_ENV !== 'production'
let module = 'website'
let modulePath = DEBUG ? '/' : `/${module}/`

const routes = [
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/website/:accountid/:projectid',
    name: 'Website',
    component: () =>
      import(/* webpackChunkName: "website" */ '../views/Website'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/custom/:accountid/:projectid/:pageid',
    name: 'Custom',
    component: () =>
      import(/* webpackChunkName: "website" */ '../views/Custom'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "website" */ '@/views/404/404'),
    meta: {
      title: ' ',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: modulePath,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
